import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import ScrollToTop from './components/ScrollToTop';

// 회사 소개
import Greeting from './pages/company/Greeting';
import History from './pages/company/History';
import OrgChart from './pages/company/OrgChart';
import Clients from './pages/company/Clients';
import Location from './pages/company/Location';
import Performance from './pages/company/Performance';

// 사업 분야
import ISManagement from './pages/business/ISManagement';
import PMO from './pages/business/PMO';
import Consulting from './pages/business/Consulting';
import QualityDiagnosis from './pages/business/QualityDiagnosis';

// 감리수행절차
import ProcedureOverview from './pages/procedure/ProcedureOverview';
import ProcedureProcess from './pages/procedure/ProcedureProcess';
import ProcedureStandards from './pages/procedure/ProcedureStandards';
import ProcedureQuality from './pages/procedure/ProcedureQuality';

// 대가 산정
import PricingInfo from './pages/pricing/PricingInfo';
import PricingCalc from './pages/pricing/PricingCalc';

// FP Code Analyzer
import FPCode from './pages/solutions/FPCode';

// 문의하기
import Contact from './pages/Contact';

// 관리자
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminInquiries from './pages/admin/AdminInquiries';
import AdminPerformances from './pages/admin/AdminPerformances';
import AdminNotices from './pages/admin/AdminNotices';
import AdminClients from './pages/admin/AdminClients';

import './App.css';

function PublicLayout({ children }) {
  return (
    <div className="app">
      <ScrollToTop />
      <Header />
      {children}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 관리자 */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="inquiries" element={<AdminInquiries />} />
          <Route path="performances" element={<AdminPerformances />} />
          <Route path="notices" element={<AdminNotices />} />
          <Route path="clients" element={<AdminClients />} />
        </Route>

        {/* 공개 페이지 */}
        <Route path="/" element={<PublicLayout><Hero /></PublicLayout>} />

        <Route path="/company/greeting" element={<PublicLayout><Greeting /></PublicLayout>} />
        <Route path="/company/history" element={<PublicLayout><History /></PublicLayout>} />
        <Route path="/company/orgchart" element={<PublicLayout><OrgChart /></PublicLayout>} />
        <Route path="/company/clients" element={<PublicLayout><Clients /></PublicLayout>} />
        <Route path="/company/location" element={<PublicLayout><Location /></PublicLayout>} />
        <Route path="/company/performance" element={<PublicLayout><Performance /></PublicLayout>} />

        <Route path="/business/is-management" element={<PublicLayout><ISManagement /></PublicLayout>} />
        <Route path="/business/pmo" element={<PublicLayout><PMO /></PublicLayout>} />
        <Route path="/business/consulting" element={<PublicLayout><Consulting /></PublicLayout>} />
        <Route path="/business/quality" element={<PublicLayout><QualityDiagnosis /></PublicLayout>} />

        <Route path="/procedure/overview" element={<PublicLayout><ProcedureOverview /></PublicLayout>} />
        <Route path="/procedure/process" element={<PublicLayout><ProcedureProcess /></PublicLayout>} />
        <Route path="/procedure/standards" element={<PublicLayout><ProcedureStandards /></PublicLayout>} />
        <Route path="/procedure/quality" element={<PublicLayout><ProcedureQuality /></PublicLayout>} />

        <Route path="/pricing/info" element={<PublicLayout><PricingInfo /></PublicLayout>} />
        <Route path="/pricing/calculator" element={<PublicLayout><PricingCalc /></PublicLayout>} />
        <Route path="/pricing" element={<Navigate to="/pricing/info" />} />

        <Route path="/business/fpcode" element={<PublicLayout><FPCode /></PublicLayout>} />
        <Route path="/solutions/fpcode" element={<Navigate to="/business/fpcode" />} />

        <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
